<template>
    <div class="container">
        <div class="about">
            <div class="form-group">
                <p class="welcome-msg">仅限管理员登录</p>
                <Form
                    ref="uInfo"
                    label-postion="top"
                    :model="uInfo"
                    :rules="ruleValidate"
                    @keydown.enter.native="toLogin"
                >
                    <form-item prop="tenantCode">
                        <span class="title">租户code</span>
                        <base-input
                            v-model="uInfo.tenantCode"
                            class="field"
                            placeholder
                            :maxlength="60"
                            :disabled="loading"
                            @input="onTenantCodeChange"
                        ></base-input>
                    </form-item>
                    <form-item prop="phone">
                        <span class="title">账号</span>
                        <base-input
                            v-model="uInfo.phone"
                            class="field"
                            placeholder
                            :maxlength="60"
                            :disabled="loading"
                        ></base-input>
                    </form-item>
                    <form-item prop="password">
                        <span class="title">密码</span>
                        <base-input
                            :disabled="loading"
                            v-model="uInfo.password"
                            type="password"
                            class="field"
                            placeholder
                            :maxlength="60"
                        ></base-input>
                    </form-item>
                </Form>
                <Button
                    class="toLogin"
                    @click="toLogin"
                    type="primary"
                    :loading="loading"
                    >登录</Button
                >
            </div>
        </div>
    </div>
</template>
<script>
import md5 from 'md5'
import { setPassport } from '_u/helper'
import { login } from '@/api/sys-user'

export default {
    data() {
        return {
            uInfo: {
                tenantCode: this.$cache.tenantCode,
                phone: '',
                password: '',
            },
            ruleValidate: {
                tenantCode: [
                    {
                        required: true,
                        message: '租户code必填',
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: '账号必填',
                    },
                ],
                password: [
                    {
                        required: true,
                        message: '密码必填',
                    },
                ],
            },
            loading: false,
        }
    },

    methods: {
        onTenantCodeChange(val) {
            this.$cache.tenantCode = val
        },
        toLogin() {
            this.$refs.uInfo.validate((valid) => {
                if (valid) {
                    // 设置租户
                    setPassport({
                        tenantCode: this.uInfo.tenantCode,
                    })

                    login({
                        tenantCode: this.uInfo.tenantCode,
                        phone: this.uInfo.phone,
                        password: md5(this.uInfo.password),
                    })
                        .then((res) => {
                            const data = res.data || {},
                                passport = data.passport

                            passport.token = data.token
                            setPassport(passport)
                        })
                        .then(() => {
                            this.$router.push('/')
                        })
                        .catch((err) => {
                            setPassport(null)
                            if (err) {
                                throw err
                            }
                        })
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
.container {
    width: 100%;
    height: 100%;
    .logo-box {
        position: relative;
        height: 100px;
        .logo {
            position: absolute;
            top: 50%;
            left: 100px;
            transform: translateY(-50%);
            height: 62px;
            width: auto;
        }
    }
    .copyright {
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 14px;
        .cr-icon {
            font-size: 18px;
            margin-right: 5px;
            padding-top: 2px;
        }
    }
}
.about {
    height: calc(~'100% - 200px');
    width: 100%;

    .form {
        &-group {
            position: absolute;
            text-align: left;
            box-sizing: border-box;
            padding: 40px 42px;
            width: 335px;
            height: 340px;
            font-size: 14px;
            right: 15%;
            top: 50%;
            border-radius: 18px;
            transform: translateY(-50%);
            background-color: rgba(255, 255, 255, 0.8);
            .welcome {
                font-weight: 700;
                font-size: 20px;
                &-msg {
                    line-height: 32px;
                    margin-bottom: 20px;
                }
            }
            .title {
                display: inline-block;
                vertical-align: top;
                width: 70px;
                height: 30px;
                line-height: 30px;
                color: #515a6e;
                background-color: #f7f5f6;
                border-radius: 5px 0 0 5px;
                text-align: center;
            }

            .field {
                display: inline-block;
                vertical-align: top;
                width: 180px;
                height: 30px;
                line-height: 30px;
                color: #515a6e;
                border: 0;
                border-radius: 0 5px 5px 0;
                background-color: #f7f5f6;

                &:focus {
                    outline: 0;
                }
            }

            .remember {
                display: inline-block;
                vertical-align: middle;
                color: #197de5;
                margin-left: 5px;
                font-size: 12px;
            }

            .checkbox {
                vertical-align: middle;
            }

            .toLogin {
                width: 100%;
                height: 36px;
                border-radius: 27px;
                color: #fff;
                border: 0;
                margin-top: 30px;
                background-color: @primary-color;
            }
        }
    }
}
</style>
